import { Route, Routes } from "react-router-dom";
import Home from "../pages/home/Home";

export default function AppRoute(){
    return (
        <Routes>
            <Route path="/" element={<Home></Home>}></Route>
        </Routes>
    )
}